import ModalCloseButton from './ModalCloseButton';

export default ModalCloseButton;
